import { Col, Row } from "reactstrap"
import styles from "./AdPlacement.module.scss"
import CustomDropdown from "../../../../../components/common/Dropdown/CustomDropDown"

const AdPlacement = () => {
  return (
    <div>
      <div className={styles["heading"]}>Basic Information</div>
      <div className="p-2 bg-white">
        <div className={styles["wrapper"]}>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Placement Type:</Col>
            <Col xs='12' lg="4">
              <div className="border border-subtle-secondary rounded p-2">
                <CustomDropdown title="Shop Now" muted />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}

export default AdPlacement
